import {Component, inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {AuthService} from "../../../../shared-module/services/auth.service";
import {ActivatedRoute, Params, Router} from "@angular/router";
import {StarsComponent} from "../../../../shared-module/components/stars/stars.component";
import RelationContact from "../../../../shared-module/model/relation-contact.model";
import Survey from "../../../../shared-module/model/survey.model";
import {ApplicationConfig, config} from "../../../../../config";
import {CardComponent} from "../../../../shared-module/components/card/card.component";
import SurveyStore from "../../../../shared-module/services/Stores/survey.store";
import Question from "../../../../shared-module/model/question.model";

@Component({
    selector: 'app-survey-landing',
    imports: [
        FormsModule,
        ReactiveFormsModule,
        StarsComponent,
        CardComponent
    ],
    providers: [
        SurveyStore
    ],
    templateUrl: './landing.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './landing.component.scss'
})

export class SurveyLandingComponent implements OnInit {
  private authService: AuthService = inject(AuthService);
  private readonly route: ActivatedRoute = inject(ActivatedRoute);
  private readonly router: Router = inject(Router);
  private readonly surveyStore: SurveyStore = inject(SurveyStore);

  public user: RelationContact | null = null;

  protected readonly config: ApplicationConfig = config;
  protected survey: Survey | null = null;

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {
      if (!params['id']) {
        return;
      }
      this.authService.getUser(['surveys']).subscribe((user: RelationContact | null) => {
        if (user === null) {
          return;
        }
        this.user = user;
        const foundSurvey: Survey | null = user.surveys?.find((survey: Survey) => survey.id == params['id']) ?? null;
        if (foundSurvey === null) {
          return;
        }
        this.survey = foundSurvey;
      })
    });
  }

  onRatingSelected(rating: number) {
    if (this.survey === null) {
      return;
    }
    this.survey.rating = rating;
    this.surveyStore.updateRating(this.survey, rating);

    if (rating === 5) {
      this.router.navigate(['/dashboard/surveys', this.survey.id, 'thanks']);
      return;
    }
    this.survey.questions.sort((a: Question, b: Question) => a.position < b.position ? -1 : 1);

    this.router.navigate(['/dashboard/surveys', this.survey.id, this.survey.questions[0].position ]);
  }
}
